module.exports = __webpack_public_path__ + "assets/img/altamar.b06b53b0.png";